import apiClient from "./APIClient";

export const getOrders = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    
  
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const res = await apiClient.get(`orders?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};

export const getCountries = () => {
  return apiClient.get('/country?lang=en').then((r) => r.data);
};

export const getTopupProductsAgent = (filters = {}) => {
  const params = new URLSearchParams();
  params.append('lang', 'en');
  params.append('_t', Date.now());
  params.append('fresh', 'true');

  if (filters.countryId) {
    params.append('countryId', filters.countryId);
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.productCategoryId) {
    params.append('productCategoryId', filters.productCategoryId);
  }
  if (filters.productTypeId) {
    params.append('productTypeId', filters.productTypeId);
  }

  const url = `/product/agent/topup?${params.toString()}`;
  
  console.log(`Fetching merchant topup products from: ${url}`);
  
  return apiClient.get(url).then((r) => {
    console.log(`Merchant products fetched: ${r?.data?.data?.length || 0} items`);
    return r?.data;
  }).catch(error => {
    console.error("Error fetching merchant products:", error);
    throw error;
  });
};
export const getOrdersC = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    

    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    const res = await apiClient.get(`orders/customer/customer?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};
export const getCurrencies = async () => {
  try {
    const res = await apiClient.get(`/exchangeRates/customer`);
      console.log("API Response:", res); 
    console.log("Response data:", res.data);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getSlabs = async () => {
  try {
    const res = await apiClient.get(`/slabs/customer`);
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getOrder = async (id, include = "") => {
  try {
    const params = include ? `?include=${include}` : "";
    const res = await apiClient.get(`orders/${id}${params}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching order:", error);
    throw error;
  }
};

export const createOrder = async (orderData) => {
  try {
    const res = await apiClient.post("orders", orderData);
    return res.data;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
export const createOrderC = async (orderData) => {
  try {
    const res = await apiClient.post("orders/customer", orderData);
    return res.data;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};

export const retryOrder = async (id) => {
  try {
    const res = await apiClient.post(`orders/${id}/retry`);
    return res.data;
  } catch (error) {
    console.error("Error retrying order:", error);
    throw error;
  }
};

export const getOrderTimeline = async (id) => {
  try {
    const res = await apiClient.get(`orders/${id}/timeline`);
    return res.data;
  } catch (error) {
    console.error("Error fetching order timeline:", error);
    throw error;
  }
};

export const getOrderLogs = async (id) => {
  try {
    const res = await apiClient.get(`orders/${id}/logs`);
    return res.data;
  } catch (error) {
    console.error("Error fetching order logs:", error);
    throw error;
  }
};